// extracted by mini-css-extract-plugin
export var errorsContainer = "_sj-1";
export var link = "_sj-0";